/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_SoftwareInputs */

const en_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software`)
};

const es_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software`)
};

const fr_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logiciels`)
};

const de_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software`)
};

const ja_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソフトウェア`)
};

const zh_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件`)
};

const ar_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برمجيات`)
};

const id_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat Lunak`)
};

const it_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software`)
};

const ru_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программное обеспечение`)
};

const pt_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software`)
};

const ko_listing_category_digital_software = /** @type {(inputs: Listing_Category_Digital_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소프트웨어`)
};

/**
* | output |
* | --- |
* | "Software" |
*
* @param {Listing_Category_Digital_SoftwareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_software = /** @type {((inputs?: Listing_Category_Digital_SoftwareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_SoftwareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_software(inputs)
	if (locale === "es") return es_listing_category_digital_software(inputs)
	if (locale === "fr") return fr_listing_category_digital_software(inputs)
	if (locale === "de") return de_listing_category_digital_software(inputs)
	if (locale === "ja") return ja_listing_category_digital_software(inputs)
	if (locale === "zh") return zh_listing_category_digital_software(inputs)
	if (locale === "ar") return ar_listing_category_digital_software(inputs)
	if (locale === "id") return id_listing_category_digital_software(inputs)
	if (locale === "it") return it_listing_category_digital_software(inputs)
	if (locale === "ru") return ru_listing_category_digital_software(inputs)
	if (locale === "pt") return pt_listing_category_digital_software(inputs)
	return ko_listing_category_digital_software(inputs)
});